import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { VisualGuideManagerService } from 'ZalamoLibrary/src/lib/ui/visual-guide/visual-guide-manager.service';

@Component({
    selector: 'lib-visual-guides-inline-list',
    templateUrl: './visual-guides-inline-list.component.html',
    styleUrls: ['./visual-guides-inline-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VisualGuidesInlineListComponent implements OnInit {
  @Output() picked = new EventEmitter();

  constructor(public visualGuideManagerService: VisualGuideManagerService) {}

  ngOnInit(): void {}

  showGuide() {}
}
